/*
 * @Author: wsx 1487444984@qq.com
 * @Date: 2025-04-26 17:41:29
 * @LastEditors: wsx 1487444984@qq.com
 * @LastEditTime: 2025-09-01 09:46:02
 * @FilePath: \Supplier\src\locales\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { App } from 'vue'
import useSettingsStore from '@/store/modules/settings'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { cloneDeep } from 'es-toolkit'
import { createI18n } from 'vue-i18n'
// 从本地存储读取语言设置，默认使用配置的 fallbackLocale
const savedLocale = localStorage.getItem('app_language')
const i18n = createI18n({
  legacy: false,
  flatJson: true,
  fallbackLocale: 'zh-cn',
  locale: savedLocale || 'zh-cn', // 优先使用本地存储语言
  messages,
  missingWarn: false,
  fallbackWarn: false,
})

function install(app: App) {
  const settingsStore = useSettingsStore()
   // 同步本地存储语言到状态管理
   if (savedLocale) {
    settingsStore.setDefaultLang(savedLocale)
  }
  i18n.global.locale.value = settingsStore.lang
  app.use(i18n)
}

function getLocales() {
  return cloneDeep(messages)
}

const localesName: Record<string, any> = {}
for (const key in messages) {
  switch (key) {
    case 'zh-cn':
      localesName[key] = '中文(简体)'
      break
    case 'zh-tw':
      localesName[key] = '中文(繁體)'
      break
    case 'en':
      localesName[key] = 'English'
      break
  }
}

// 用于路由 meta 配置，方便在 VSCode I18n Ally 插件进行显示，无实际作用
function $t(key: string) {
  return key
}

export default { install }

export {
  $t,
  getLocales,
  i18n,
  localesName,
}
